import { Component, Input, OnInit } from '@angular/core';
import { Step } from 'projects/mydocma/import-export/src/lib/stepper/step/step';
import { StepComponent, StepData } from 'projects/mydocma/import-export/src/lib/stepper/step/step.component';
import { StepperService } from 'projects/mydocma/import-export/src/lib/stepper/stepper.service';
import { from } from 'rxjs';
import { NavigationService } from '../navigation.service';
import { Step3Service } from './step3.service';

@Component({
  selector: 'app-stepper-navigation-step3',
  templateUrl: './step3.component.html',
  styleUrls: ['./step3.component.scss'],
  providers: [
    Step3Service
  ]
})
export class Step3Component implements OnInit, StepComponent {

  @Input()
  step: Step;
  
  options = []; 
  selectedType = null;


  constructor(private readonly stepperService: StepperService,
              private readonly navigationService: NavigationService,
              private readonly step3Service: Step3Service
              ) { }
  
  ngOnInit() {
  }

  enter() {
    // this.stepperService.setStepData(this.step, { valid: true, error: '', data: {} });
    const prev = this.stepperService.getStepByIndex(1);

    //this.options = ['A1', 'A22']

    this.navigationService.loading = true;
    from(this.step3Service.load(prev.data)).subscribe(o=> {
      this.options = o
      this.navigationService.loading = false;
    }
      
    );


  }

  async validate(): Promise<StepData> {
    return {valid: false}
  }

  async next() {
    await this.stepperService.nextStep();
  }

  reset() {
    this.selectedType = null;
  }
}
